import { useQuery } from "@tanstack/react-query";
import {
  getNotFoundCandidates,
  NotFoundCandidateResponse,
} from "@/shared/actions/campanas/migracion.actions";

type CampaignType = "MIGRATION" | "FIDELIZATION";
type DataSourceType = "" | "CSV" | "INTERNAL_SEARCH";

export const useNotFoundCandidates = (
  module: CampaignType,
  open: boolean,
  dataSource?: DataSourceType
) => {
  const query = useQuery({
    queryKey: ["not-found-candidates", module, dataSource],
    queryFn: () => getNotFoundCandidates(module, dataSource),
    enabled: open && !!module && !!dataSource,
    refetchOnWindowFocus: false,
  });

  const resolvedData = ((query.data as any)?.data ??
    query.data ??
    []) as NotFoundCandidateResponse[];

  return {
    data: resolvedData,
    loading: query.isLoading,
    error: query.isError,
    refetch: query.refetch,
  };
};